/*
 * Runek
 * http://www.scoopthemes.com/
 *
 * Copyright (c) 2014, ScoopThemes
 * Licensed under the BSD license.
 */
'use strict';

var appMaster = {

    flashAlert: function()
    {
        $('div.flash-message').not('.alert-important').delay(5000).slideUp(350);
    },

    navSpy: function(){
        /* affix the navbar after scroll below header */
        $('#nav.navbar-static-top').affix({
            offset: {
                top: $(window).height()
            }
        });

        /* highlight the top nav as scrolling occurs */
        $('body').scrollspy({
            target: '#nav'
        });
    },

    smoothScroll: function() {
        // Smooth Scrolling
        $('a[href*="#"]').click(function() {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {

                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {
                    $('html,body').delay(200).animate({
                        scrollTop: target.offset().top - 100
                    }, 1000);
                    return false;
                }
            }
        });
    },

    scollToTop: function() {
        /* smooth scrolling for scroll to top */
        $('.scroll-top').click(function() {
            $('body,html').animate({
                scrollTop: 0
            }, 1000);
        });
    },

    revSlider: function() {

        var docHeight = $(window).height();

        var revapi;
        revapi = $('.tp-banner').revolution({
                delay: 7000,
                startwidth: 1170,
                startheight: docHeight,
                hideThumbs: 10,
                fullWidth: "off",
                fullScreen: "on",
                onHoverStop: "off",
                touchenabled:false,
                fullScreenOffsetContainer: "",
                navigationHAlign: "right",
                navigationVAlign:"bottom",
                navigationHOffset: 80,
                navigationStyle:"square",
                soloArrowLeftHalign:"left",
                soloArrowLeftValign:"bottom",
                soloArrowRightHalign:"left",
                soloArrowRightValign:"bottom",
                soloArrowLeftVOffset:55,
                soloArrowRightVOffset:10,
                dottedOverlay: 'none'
            });
    },

    stellar: function(){
        $(window).stellar();
    },

    isoTop: function(){
        var $container = $('#container');
        // init
        $container.isotope({
            // options
            itemSelector: '.item'
        });

        $('#filters').on('click', 'button', function() {
            $('#filters button').removeClass("current");
            $(this).addClass("current");
            var filterValue = $(this).attr('data-filter');
            $container.isotope({
                filter: filterValue
            });
        });
    },

    canvasHack: function(){
        // so non-IE won't freak out in canvasInit
        var G_vmlCanvasManager;

        function canvasInit() {
            var cv = document.createElement('canvas');
            if (G_vmlCanvasManager != undefined) { // ie IE
                G_vmlCanvasManager.initElement(cv);
            }

            if (cv.getContext) {
                var ctx = cv.getContext('2d');
            }
        }
    },


    datepicker: function() {
        $('.my-datepicker').datepicker({
            format: 'yyyy-mm-dd'
        });
    },

    slider: function() {
        $('.carousel').carousel({
            interval: 5000 //changes the speed
        })
    },

    locationSelection: function() {

        $('.location').on('click', function(e) {
            var loc_id = $(this).data('mylocation');

            $('#location_id').val(loc_id);
        })

    },

    scrollOnLoad: function() {

        try {
            //take HREF and split at anchor
            var $_elem = $('#' + $(location).attr('href').split('#')[1]);
            //find class of anchor element
            var $_others = $('.' + $_elem.attr('class'));
            //measure window height and element height
            //if the window height is smaller that twice the element height, then use regular offset
            //if not, use calculated window height
            var wHeight = ($(window).height() < ($_elem.height() * 2)) ? 0 : $(window).height() - ($_elem.height() * 2);
            var offset = $_elem.offset();
            var offsetTop = offset.top - wHeight;

            //console.log(wHeight);

            $(window).load(function () {
                $('body, html').scrollTop(0);
                $('body, html').delay(500).animate({ opacity: 1, scrollTop: offsetTop }, 'slow', function () {
                    $_others.not($_elem).animate({ opacity: '.3' }).delay(5000).animate({ opacity: '1' }).stop();
                });
            });

        } catch (err) {

            return false;

        }
    }

};


$(document).ready(function() {
    //appMaster.revSlider();

    appMaster.navSpy();
    appMaster.flashAlert();
    appMaster.locationSelection();
    //appMaster.stellar();
    //appMaster.canvasHack();
    //appMaster.datepicker();
    appMaster.smoothScroll();
    appMaster.scollToTop();
});